import React from "react";

interface StatusBarProps {
  data: Record<string, string | number>;
  keyClassName?: string;
  valueClassName?: string;
  color?: "red" | "green" | "yellow" | "blue"; // New color prop
}

const StatusBar: React.FC<StatusBarProps> = ({
  data,
  keyClassName = "bg-gray-200 text-gray-700",
  valueClassName = "bg-primary-100 text-primary-800",
  color, // Destructure the new color prop
}) => {
  // Define color classes
  const colorClasses = {
    red: "bg-red-100 text-red-800",
    green: "bg-green-100 text-green-800",
    yellow: "bg-yellow-100 text-yellow-800",
    blue: "bg-primary-100 text-primary-800",
  };

  // Determine the value class based on the color prop
  const computedValueClassName = color ? colorClasses[color] : valueClassName;

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(data).map(([key, value]) => (
        <div key={key} className="flex rounded-lg overflow-hidden shadow-sm">
          <span className={`px-2 py-1 text-sm font-medium ${keyClassName}`}>
            {key}
          </span>
          <span
            className={`px-2 py-1 text-sm font-medium ${computedValueClassName}`}
          >
            {value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default StatusBar;
